<!--
 * @Author: ezhizao 庄德政
 * @LastEditors: ezhizao 庄德政
 * @Description: 
-->
<template>
  <div class="main-container scrollbar-y">
    <div class="page-header">
      <div class="page-title">账号与密码</div>
    </div>
    <div class="page-body">
      <el-form class="ezz-form" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-card>
              <div slot="header" class="clearfix">
                <span>账户信息</span>
              </div>
              <el-form-item size="mini" label="头像">
                <el-upload class="avatar-uploader" :action="this.$apis.uploadImage" :show-file-list="false" :before-upload="beforeAvatarUpload" :on-success="handleAvatarSuccess">
                  <img v-if="form.head_portrait" :src="form.head_portrait" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
              <el-form-item label="姓名" style="margin-top: 16px;">
                <el-input v-model="form.name" size="small"></el-input>
              </el-form-item>
              <el-form-item label="昵称" style="margin-top: 16px;">
                <el-input v-model="form.nickname" size="small"></el-input>
              </el-form-item>
              <el-form-item label="电话" style="margin-top: 16px;">
                <el-input v-model="form.phone" size="small"></el-input>
              </el-form-item>
              <el-form-item label="" style="margin-top: 16px;">
                <el-button size="small" type="success" @click="handlerSaveInfo">保存账户信息</el-button>
              </el-form-item>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card>
              <div slot="header" class="clearfix">
                <span>登录名与密码</span>
              </div>
              <el-form-item label="登录名">
                <el-input v-model="form.raw_code" size="small"></el-input>
                <div style="margin-top: -10px;">设置账号后，可以通过账号和密码，登录系统</div>
              </el-form-item>
              <template v-if="user.psw">
                <el-form-item label="旧密码">
                  <el-input type="password" v-model="form.oldPassword" size="small"></el-input>
                </el-form-item>
                <el-form-item label="新密码" style="margin-top: 16px;">
                  <el-input type="password" v-model="form.newPassword" size="small"></el-input>
                </el-form-item>
                <el-form-item label="确认新密码" style="margin-top: 16px;">
                  <el-input type="password" v-model="form.confirmPassword" size="small"></el-input>
                </el-form-item>
              </template>
              <template v-else>
                <el-form-item label="密码">
                  <el-input type="password" v-model="form.newPassword" size="small"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" style="margin-top: 16px;">
                  <el-input type="password" v-model="form.confirmPassword" size="small"></el-input>
                </el-form-item>
              </template>
              <el-form-item label="" style="margin-top: 16px;">
                <el-button size="small" type="warning" @click="handlerSavePassword">保存账户名与密码</el-button>
              </el-form-item>
            </el-card>
          </el-col>
        </el-row>
        <el-divider></el-divider>
      </el-form>
    </div>
  </div>
</template>
<style scoped>
  .avatar-uploader{
    width: 54px;
    height: 54px;
    line-height: 54px;
    margin: 0;
  }
</style>
<script>
export default {
  name: 'accout_index',
  data: () => {
    return {
      user: sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user')) : { name: '未登录' },
      form: {
        id: '',
        head_portrait: '',
        raw_code: '',
        name: '',
        nickname: '',
        phone: '',
        psw: ''
      },
      fileList: [],
      apis: {
        saveInfo: window.g.baseUrl + 'plugin/user/generic/default/saveInfo',
        savePassword: window.g.baseUrl + 'plugin/user/generic/default/savePassword'
      }
    }
  },
  mounted: function () {
    this.form = {
      id: this.user.id,
      head_portrait: this.user.head_portrait,
      raw_code: this.user.raw_code,
      name: this.user.name,
      nickname: this.user.nickname,
      phone: this.user.phone,
      psw: this.user.psw,
      oldPassword: '',
      newPassword: '',
      confirmPassword: ''
    }
  },
  methods: {
    beforeAvatarUpload(file) {
      const isJPG = (file.type === 'image/jpeg' || file.type === 'image/png')
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 jpg 或 png 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },

    handleAvatarSuccess(res, file, fileList) {
      const _this = this
      _this.form.head_portrait = this.$apiroot + res.url
    },
    handlerSaveInfo: function () {
      const _this = this
      _this.post(this.apis.saveInfo,_this.form, function (res) {
        const _json = res.data
        if (_json.status === 'ok') {
          _this.$message({
            message: '操作成功',
            type: 'success'
          })
          sessionStorage.setItem('user', JSON.stringify(_json.user))
          _this.user = _json.user
        } else {
          _this.$message.error(_json.msg)
        }
      })
    },
    handlerSavePassword: function () {
      const _this = this
      if (_this.form.newPassword !== '') {
        if (_this.form.raw_code === '') {
          _this.$message.error('登录名不能为空')
          return
        }
        if (_this.form.psw && _this.form.oldPassword === '') {
          _this.$message.error('旧密码不能为空')
          return
        }
        if (_this.form.newPassword !== _this.form.confirmPassword) {
          _this.$message.error('两次密码不相等')
          return
        }
      }
      _this.post(this.apis.savePassword,_this.form, function (res) {
        const _json = res.data
        if (_json.status === 'ok') {
          _this.$message({
            message: '操作成功',
            type: 'success'
          })
          sessionStorage.setItem('user', JSON.stringify(_json.user))
          _this.user = _json.user
          
          _this.form.oldPassword = '',
          _this.form.newPassword = '',
          _this.form.confirmPassword = ''
        } else {
          _this.$message.error(_json.msg)
        }
      })
    }
  }
}
</script>